// MappingPage.tsx
import React, { useState } from 'react';
import { Card, Tabs, Table, Select, Tag, Button } from 'antd';
import { DownOutlined, UpOutlined } from '@ant-design/icons';
const { Option } = Select;
const { TabPane } = Tabs;

interface MappingRow {
  input: string;
  sampleValue: string;
  crmColumn: string | null;
}

interface FileMapping {
  fileName: string;
  tag: string;
  mapped: number;
  unmapped: number;
  data: MappingRow[];
}

const sampleMappings: FileMapping[] = [
  {
    fileName: 'RAW - 0101 - 31122023 - DDMS Service - Báo cáo chăm sóc khách hàng - Vĩnh Long.xlsx',
    tag: 'DDMS - SERVICES',
    mapped: 130,
    unmapped: 0,
    data: [
      { input: 'Mã định danh khách hàng', sampleValue: '241104498495', crmColumn: null },
      { input: 'Khách hàng', sampleValue: 'Bùi Thảo Hiền', crmColumn: null },
      { input: 'Điện thoại', sampleValue: '0344730000', crmColumn: 'Số điện thoại' },
      { input: 'Email', sampleValue: 'hien.bui@bluebolt.consulting', crmColumn: 'Email' },
      { input: 'Ngày sinh (dd/MM/yyyy)', sampleValue: '01/01/1990', crmColumn: 'Ngày sinh' },
      { input: 'Địa chỉ', sampleValue: '32 đường số 9, City park', crmColumn: 'Địa chỉ' },
    ],
  },
  {
    fileName: 'RAW - 01012023 - 30062025 - Sales Bảng kê SR XHD - Vĩnh Long',
    tag: 'DDMS - Sale',
    mapped: 2,
    unmapped: 4,
    data: [
      { input: 'Mã định danh khách hàng', sampleValue: '241104498495', crmColumn: null },
      { input: 'Khách hàng', sampleValue: 'Bùi Thảo Hiền', crmColumn: null },
      { input: 'Điện thoại', sampleValue: '0344730000', crmColumn: 'Số điện thoại' },
      { input: 'Email', sampleValue: 'hien.bui@bluebolt.consulting', crmColumn: 'Email' },
      { input: 'Ngày sinh (dd/MM/yyyy)', sampleValue: '01/01/1990', crmColumn: 'Ngày sinh' },
      { input: 'Địa chỉ', sampleValue: '32 đường số 9, City park', crmColumn: 'Địa chỉ' },
    ],
  },
  {
    fileName: 'RAW - 01012023 - 30062025 - Bảng Kê CSKH KD Sau 3 ngày PE 2017 - Vĩnh Long',
    tag: 'DDMS - SERVICES',
    mapped: 130,
    unmapped: 0,
    data: [
      { input: 'Mã định danh khách hàng', sampleValue: '241104498495', crmColumn: null },
      { input: 'Khách hàng', sampleValue: 'Bùi Thảo Hiền', crmColumn: null },
      { input: 'Điện thoại', sampleValue: '0344730000', crmColumn: 'Số điện thoại' },
      { input: 'Email', sampleValue: 'hien.bui@bluebolt.consulting', crmColumn: 'Email' },
      { input: 'Ngày sinh (dd/MM/yyyy)', sampleValue: '01/01/1990', crmColumn: 'Ngày sinh' },
      { input: 'Địa chỉ', sampleValue: '32 đường số 9, City park', crmColumn: 'Địa chỉ' },
    ],
  },
];

const MappingTable = ({ data = {} as any, stData = {} as any, onChange = (data: any, type?: string) => {} }) => {
  const columns = [
    {
      title: 'Dữ liệu trong tệp nhập liệu',
      dataIndex: 'input',
      className: 'mapping-col fw-500',
    },
    {
      title: 'Giá trị dòng thứ nhất trên tệp',
      dataIndex: 'sampleValue',
      className: 'mapping-col',
    },
    {
      title: 'Cột dữ liệu trên CRM',
      dataIndex: 'crmColumn',
      className: 'mapping-col',
      render: (_: any, record: any) => {
        const options = stData.obSource[data.isSourceId || 1] ? stData.obSource[data.isSourceId || 1].columns : [];
        const selectedValues = Object.values(stData.filesParams[data.name] || {});
        const filteredOptions = options.filter(
          (option: any) =>
            !selectedValues.includes(option.column) ||
            stData.filesParams[data.name][record.input] === option.column
        );
        return (
          <div>{stData.obSourceColumns[stData.filesParams[data.name][record.input]] ? stData.obSourceColumns[stData.filesParams[data.name][record.input]].name : ''}</div>
          // <Select
          //   className='system-select rs-select'
          //   placeholder="Chọn 1 giá trị"
          //   value={stData.filesParams[data.name][record.input]}
          //   style={{ width: '100%' }}
          //   showSearch
          //   optionFilterProp="children"
          //   filterOption={(input, option) =>
          //     (option?.children ?? '')
          //       .toString()
          //       .toLowerCase()
          //       .normalize('NFD')
          //       .replace(/[\u0300-\u036f]/g, '')
          //       .includes(
          //         input
          //           .toLowerCase()
          //           .normalize('NFD')
          //           .replace(/[\u0300-\u036f]/g, '')
          //       )
          //   }
          //   onChange={(val) => {
          //     stData.filesParams[data.name][record.input] = val
          //     onChange({ filesParams: stData.filesParams});
          //   }}
          //   disabled
          // >
          //   {filteredOptions.map((option: any) => (
          //     <Option key={option.column} value={option.column}>{option.name}</Option>
          //   ))}
          // </Select>
        )
      },
    },
  ];

  const dataRow = data.headers.map((item: any) => ({
    input: item,
    sampleValue: data.firstFiveRows[0] && data.firstFiveRows[0][item] ? data.firstFiveRows[0][item] : '',
    crmColumn: null,
  }));

  return (
    <div className="mapping-tabs">
      <Table className='scroll-y-table' columns={columns} dataSource={dataRow} rowKey="input" pagination={false} scroll={{ y: 500 }} />
    </div>
    // <Tabs defaultActiveKey="all" className="mapping-tabs">
    //   <TabPane tab={`Tất cả (${dataRow.length})`} key="all">
    //     <Table className='scroll-y-table' columns={columns} dataSource={dataRow} rowKey="input" pagination={false} scroll={{ y: 500 }} />
    //   </TabPane>
    //   <TabPane tab={`Đã mapping (${dataRow.filter((d: any) => stData.filesParams[data.name][d.input]).length})`} key="mapped">
    //     <Table className='scroll-y-table' columns={columns} dataSource={dataRow.filter((d: any) => stData.filesParams[data.name][d.input])} rowKey="input" pagination={false} scroll={{ y: 500 }}/>
    //   </TabPane>
    //   <TabPane tab={`Chưa mapping (${dataRow.filter((d: any) => !stData.filesParams[data.name][d.input]).length})`} key="unmapped">
    //     <Table className='scroll-y-table' columns={columns} dataSource={dataRow.filter((d: any) => !stData.filesParams[data.name][d.input])} rowKey="input" scroll={{ y: 500 }} pagination={false} />
    //   </TabPane>
    // </Tabs>
  );
};

const MappingCard = ({file = {} as any, stData = {} as any, onChange = (data: any, type?: string) => {}}) => {
  const [expanded, setExpanded] = useState(false);
  let countMapping = 0
  let countUnmapping = 0
  Object.keys(stData.filesParams[file.name] || {}).forEach((key) => {
    if (stData.filesParams[file.name][key]) {
      countMapping++;
    } else {
      countUnmapping++;
    }
  });

  return (
    <Card
      className="mapping-card"
      title={
        <div className="mapping-header">
          <div className="icon-svg">
            <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fillRule="evenodd" clipRule="evenodd" d="M6.14461 0H14.1767L20.9738 7.09489V20.873C20.9738 22.5985 19.5811 24 17.8556 24H6.14461C4.42782 24 3.02637 22.5985 3.02637 20.873V3.11824C3.02634 1.40145 4.42782 0 6.14461 0Z" fill="#00733B"/>
              <path opacity="0.3" fillRule="evenodd" clipRule="evenodd" d="M14.168 0V7.03358H20.9738L14.168 0Z" fill="white"/>
              <path d="M10.4895 17.4744H9.32452L8.52745 16.1343L7.73036 17.4744H6.55664L7.94059 15.1445L6.72309 13.1211H7.89678L8.52742 14.1722L9.14931 13.1211H10.323L9.11425 15.1533L10.4895 17.4744ZM10.9012 17.4744V13.1211H12.0136V16.5284H13.9055V17.4744H10.9012V17.4744ZM15.7449 17.527C15.307 17.527 14.9216 17.3868 14.5888 17.1153C14.2647 16.8525 14.0807 16.5197 14.0544 16.1255L15.0092 15.8452C15.0355 16.0555 15.1231 16.2394 15.272 16.3796C15.4296 16.5197 15.6048 16.5898 15.7975 16.5898C15.9552 16.5898 16.0866 16.5547 16.1917 16.4847C16.288 16.4146 16.3406 16.3182 16.3406 16.2044C16.3406 16.108 16.2968 16.0292 16.2179 15.9591C16.1391 15.8978 16.034 15.8452 15.9114 15.8015C15.7887 15.7577 15.6398 15.7139 15.4909 15.6788C15.3333 15.635 15.1756 15.5825 15.0267 15.5124C14.869 15.4511 14.7289 15.3723 14.6063 15.2759C14.4749 15.1883 14.3785 15.0569 14.2997 14.8905C14.2208 14.7328 14.177 14.5401 14.177 14.3212C14.177 13.962 14.3259 13.6642 14.6325 13.4277C14.9391 13.1825 15.307 13.0686 15.7362 13.0686C16.1654 13.0686 16.542 13.1737 16.8573 13.3752C17.1727 13.5854 17.3741 13.8569 17.4529 14.1898L16.4544 14.6102C16.4106 14.4263 16.323 14.2774 16.2004 14.1635C16.0777 14.0584 15.9201 13.9971 15.7362 13.9971C15.596 13.9971 15.4909 14.0321 15.4033 14.0847C15.3245 14.1372 15.2894 14.2161 15.2894 14.3124C15.2894 14.4 15.342 14.4788 15.4471 14.5402C15.5522 14.5927 15.6924 14.6365 15.85 14.6628C16.0077 14.6891 16.1829 14.7329 16.3668 14.7942C16.5595 14.8643 16.7259 14.9343 16.8923 15.0307C17.05 15.1183 17.1814 15.2672 17.2865 15.4599C17.4004 15.6614 17.4529 15.8979 17.4529 16.1694C17.4529 16.5723 17.2953 16.9052 16.9799 17.1504C16.6646 17.3956 16.253 17.527 15.7449 17.527Z" fill="white"/>
            </svg>
          </div>
          <div className="right-content">
            <span className='fz-14-475467'>{file.name}</span>
            {
              file.isSource && <Tag className="mapping-tag">{file.isSource}</Tag>
            }
            {/* <div className="mapping-status mt-10">
              <div className="green">Đã mapping <span style={{ color: '#1890FF' }}>({countMapping})</span></div>
              <div className="red">Chưa mapping <span style={{ color: '#FF4D4F' }}>({countUnmapping})</span></div>
            </div> */}
          </div>
        </div>
      }
      extra={
        <Button type="link" onClick={() => setExpanded(!expanded)} className="mapping-toggle">
          {expanded ? 'Rút gọn' : 'Xem chi tiết'} {expanded ? <UpOutlined /> : <DownOutlined />}
        </Button>
      }
    >
      {expanded && <MappingTable data={file} stData={stData} onChange={(data, type) => {
          if (!type) {
            onChange({ ...data });
          }
        }}/>}
    </Card>
  );
};

const ImportDataStep2 = ({ stData = {} as any, onChange = (data = {}, type = null) => {} }) => {
  return (
    <div className="step2-container">
      {stData.dataFiles.map((file: any, index: any) => (
        <MappingCard key={index} file={file} stData={stData} onChange={(data, type) => {
          if (!type) {
            onChange({ ...data });
          }
        }} />
      ))}
    </div>
  );
};

export default ImportDataStep2;
